/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class FileUnknownIcon extends BaseIcon {
  getChildren = () => [
    <polygon fill={ this.getColor() } points="15 12.55 15 0 1 0 1 16 11.55 16 15 12.55"/>,
    <circle fill="#fff" cx="5" cy="8" r="1"/>,
    <circle fill="#fff" cx="8" cy="8" r="1"/>,
    <circle fill="#fff" cx="11" cy="8" r="1"/>
  ]
  getViewBox = () => '0 0 16 16'
}
